import { Component, Output, Input, EventEmitter } from '@angular/core';
import { StringDatePipe } from '../../../ui-helper/string-date.pipe';
import * as model from "../../../models";
@Component({
	selector: "event-with-venue-list",
	templateUrl: "./event-with-venue-list.html",
	styles: [require("./event-with-venue-list.scss")]
})
export class EventWithVenueList {
	@Input() events: model.EventWithVenue[]
	@Input() orderBy: string;
	@Output() orderByChange = new EventEmitter<string>();
	@Output() navigateToDetailClicked = new EventEmitter <{eventId: number, seatingplanUuid: string, userSetHasVisualQuota: boolean}>();

	protected currentPage: number;
	constructor() {
	}

	pageChanged(pageNumber) {
		this.currentPage = pageNumber;
	}

	getCategoryInfoColor(categoryInfo: model.CategoryInfo) {

		if (categoryInfo.availableTickets <= 0) {
			return "red";
		}
		if (categoryInfo.availableTickets <= 10) {
			return "yellow";
		}
		return "green"
	}

}




// WEBPACK FOOTER //
// ./src/app/components/events-on-sale/event-with-venue-list/event-with-venue-list.component.ts